import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import InvestmentCalculator from "../components/InvestmentCalculator";

export function toStartupAssets(startups) {
  return (startups || []).map((s) => ({
    id: s.slug,
    name: s.name,
    sublabel: `${s.sector} · latest mark ${s.latest_valuation >= 1000 ? `$${(s.latest_valuation / 1000).toFixed(1)}T` : `$${s.latest_valuation}B`} (${s.latest_year})`,
    kind: "startup",
    entries: (s.rounds || []).map((r) => ({
      id: `${r.label}-${r.year}`,
      label: `${r.label} · ${r.year}`,
      multiple: s.latest_valuation / r.valuation,
      detail: `Entry at ${r.valuation >= 1000 ? `$${(r.valuation / 1000).toFixed(1)}T` : `$${r.valuation}B`} (${r.year}), against a ${s.latest_valuation >= 1000 ? `$${(s.latest_valuation / 1000).toFixed(1)}T` : `$${s.latest_valuation}B`} mark in ${s.latest_year}.`,
    })),
  })).filter((a) => a.entries.length);
}

export default function Calculator() {
  const [assets, setAssets] = useState(null);

  useEffect(() => {
    api.get("/public/startups").then((r) => setAssets(toStartupAssets(r.data))).catch(() => setAssets([]));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="max-w-5xl w-full mx-auto px-6 pt-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 w-fit">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera</span>
          <span className="t-cap text-muted-s ml-2 hidden sm:inline">solera.vc</span>
        </Link>
        <Link to="/login" className="t-label hover:!text-[#E8E6E1]" data-testid="calc-login-link">Login</Link>
      </header>

      <div className="flex-1 max-w-5xl w-full mx-auto px-6 py-16 rise" data-testid="public-calculator-page">
        <span className="t-label">Model the outcome</span>
        <h1 className="t-h1 text-bone mt-3 max-w-3xl">What an early position in a generational company can become.</h1>
        <p className="t-small text-muted-s mt-4 measure">
          Choose a company, choose the round you might have entered, and set an amount. The model applies the change in
          valuation from that round to the latest reported mark. Build a basket to see a blended outcome. Every figure is
          illustrative and drawn from public reporting.
        </p>

        <div className="mt-12">
          {assets === null ? (
            <p className="t-label">Loading</p>
          ) : (
            <InvestmentCalculator
              assets={assets}
              testid="public-calc"
              footer={
                <div className="hairline mt-10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-testid="calc-invitation">
                  <p className="t-small text-muted-s measure">Solera invests in mid and late stage private companies. Access is by invitation.</p>
                  <div className="flex gap-4 shrink-0">
                    <Link to="/register" className="btn-primary inline-block" data-testid="calc-register-button">Complete registration</Link>
                    <Link to="/#contact" className="btn-ghost inline-block" data-testid="calc-contact-button">Write to Solera</Link>
                  </div>
                </div>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
